import "./TextField.css";

const TextField = ({ onChange, value, placeholder, type, className }) => {
	return (
		<input
			onChange={onChange}
			className={className || "Default-Field"}
			placeholder={placeholder || "Task Tracking Number / Company Code"}
			type={type || "text"}
			value={value}
		/>
	);
};

TextField.defaultProps = {
	value: "",
	type: "text",
	placeholder: "Task Tracking Number / Company Code",
	className: "Default-Field",
};

export default TextField;
